document.addEventListener("DOMContentLoaded", function () {
  const aboutBlockLinks = document.querySelectorAll(".about-block-wrapper a");

  aboutBlockLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.id.toLowerCase();

      const aboutContentDivs = document.querySelectorAll("convx-page-about-content div.about-content-wrapper");

      for (const div of aboutContentDivs) {
        const divId = div.id.toLowerCase();

        if (divId === targetId) {
          div.scrollIntoView({ behavior: "smooth", block: "start" });
          break;
        }
      }
    });
  });
});
